module.exports = __webpack_public_path__ + "static/media/ios_app_store.2e177fae.svg";